import React from "react"
import { gtmTracking } from "@/utils/gtm-tracking"

const CallToActionBanner = ({
  title,
  description,
  footerText,
  background,
  action,
  secondaryAction,
  children,
  className = "",
}) => {
  const PrimaryActionComponent = action
  return (
    <div
      className={`${className} call-to-action-banner ${
        background ? `call-to-action-banner--${background}` : ""
      }`}
    >
      <div className="call-to-action-banner__inner">
        {title && (
          <h2 className="call-to-action-banner__title call-to-action-banner__title col-md-8 col-md-offset-2">
            {title}
          </h2>
        )}

        {description && (
          <p className="p--lg call-to-action-banner__description">
            {description}
          </p>
        )}

        {children && children}

        <div className="call-to-action-banner__actions mt-4">
          {typeof action === "function" ? (
            action({
              className: `call-to-action-banner__button btn ${
                background === "blue" || background === "black"
                  ? "btn--light"
                  : ""
              }`,
              onClick: () =>
                gtmTracking("CTA Click", "Try Free", "CTA Banner")(),
            })
          ) : (
            <PrimaryActionComponent
              className={`call-to-action-banner__button btn ${
                background === "blue" || background === "black"
                  ? "btn--light"
                  : ""
              }`}
              onClick={() =>
                gtmTracking("CTA Click", "Try Free", "CTA Banner")()
              }
            />
          )}

          {secondaryAction}
        </div>

        {footerText && (
          <p className="p--sm call-to-action-banner__footer">{footerText}</p>
        )}
      </div>
    </div>
  )
}

export default CallToActionBanner
